import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button } from '@material-ui/core';
import { IUpsell } from 'interface/upsell';
import { SyntheticEvent } from 'react';

interface IProps {
  upsell: IUpsell;
  toggleDetails: () => void;
  onConfirm: (event: SyntheticEvent) => void;
}

const useStyles = makeStyles((theme) => ({
  whiteButton: {
    marginLeft: theme.spacing(2),
    background: theme.palette.grey[200],
    '&:hover': {
      background: theme.palette.grey[300],
    },
    '& > span': {
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 600,
      color: theme.palette.grey[600],
      '& svg': {
        color: theme.palette.grey[600],
        fontSize: '24px !important',
      },
    },
    '@media(max-width: 1440px)': {
      padding: theme.spacing(1, 2),
      '& > span': {
        fontSize: 10,
      },
    },
  },
  greenButton: {
    '& > span': {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 14,
      color: theme.palette.common.white,
    },
    '@media(max-width: 1440px)': {
      padding: theme.spacing(1, 2),
      '& > span': {
        fontSize: 10,
      },
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2),
  },
}));

const Offer = (props: IProps) => {
  const classes = useStyles();
  return (
    <div id='card-header'>
      <div className={classes.container}>
        <Button
          id='upsell-btn-buy'
          onClick={props.onConfirm}
          variant='contained'
          color='primary'
          className={classes.greenButton}
        >
          {props.upsell.label_text ?? 'Compre agora'}
        </Button>
        <Button id='upsell-btn-info' onClick={props.toggleDetails} variant='contained' className={classes.whiteButton}>
          Informações
        </Button>
      </div>
    </div>
  );
};

export default Offer;
